import React, { useEffect, useRef } from 'react';
import { useGetAuthInspectQuery, usePostAuthRefreshMutation } from '../../store/backendApi';

const REFRESH_CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes in milliseconds
const REFRESH_THRESHOLD = 10 * 60; // 5 minutes in seconds

export const SilentRefresh: React.FC = () => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  // Use the inspect endpoint to check session status
  const { refetch: refetchInspect } = useGetAuthInspectQuery();

  // Use the refresh endpoint to refresh tokens
  const [refreshToken] = usePostAuthRefreshMutation();

  const checkAndRefreshToken = async () => {
    // Refetch the inspect data to get the latest session information
    const result = await refetchInspect();

    if (result.data) {
      const { sessionExpiresAt, rememberMe } = result.data;
      const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
      const timeUntilExpiry = sessionExpiresAt - currentTime;

      // If session expires in less than 5 minutes AND rememberMe is active, refresh the token
      if (timeUntilExpiry < REFRESH_THRESHOLD && rememberMe) {
        console.log('Session expiring soon, refreshing token silently...');
        await refreshToken();
        console.log('Token refreshed successfully');
      }
    }
  };

  useEffect(() => {
    // Start the interval to check for token refresh every 5 minutes
    intervalRef.current = setInterval(checkAndRefreshToken, REFRESH_CHECK_INTERVAL);

    // Also check immediately when the component mounts
    checkAndRefreshToken();

    // Cleanup function to clear the interval when component unmounts
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  // This component doesn't render anything visible
  return null;
};
